export default "__VITE_ASSET__vNlBaHoC__"